import { isUndefined } from 'lodash';

const US_PHONE_NUMBER_LENGTH = 10;
const AREA_CODE_LENGTH = 3;
const US_PHONE_NUMBER_CHUNKS = [3, 3, 4];

export const normalizePhoneNumber = (value?: string) => {
  if (isUndefined(value)) return '';

  const currentInput = value.replace(/\D/g, '');
  return (currentInput.length <= US_PHONE_NUMBER_LENGTH)
    ? `(${currentInput.slice(0, AREA_CODE_LENGTH)}) ${currentInput.slice(AREA_CODE_LENGTH, AREA_CODE_LENGTH + US_PHONE_NUMBER_CHUNKS[1])}-${currentInput.slice(AREA_CODE_LENGTH + US_PHONE_NUMBER_CHUNKS[1], AREA_CODE_LENGTH + US_PHONE_NUMBER_CHUNKS[1] + US_PHONE_NUMBER_CHUNKS[2])}`
    : '+' + currentInput.slice(0, US_PHONE_NUMBER_LENGTH);
};

export const normalizePhoneNumberNoPlaceholder = (value?: string): string => {
  if (isUndefined(value)) return '';

  const currentInput = value.replace(/\D/g, '');
  const inputLen = currentInput.length;

  if (inputLen < AREA_CODE_LENGTH) return currentInput;
  if (inputLen < AREA_CODE_LENGTH + US_PHONE_NUMBER_CHUNKS[1]) return `(${currentInput.slice(0, AREA_CODE_LENGTH)}) ${currentInput.slice(AREA_CODE_LENGTH)}`;
  return `(${currentInput.slice(0, AREA_CODE_LENGTH)}) ${currentInput.slice(AREA_CODE_LENGTH, AREA_CODE_LENGTH + US_PHONE_NUMBER_CHUNKS[1])}-${currentInput.slice(AREA_CODE_LENGTH + US_PHONE_NUMBER_CHUNKS[1], AREA_CODE_LENGTH + US_PHONE_NUMBER_CHUNKS[1] + US_PHONE_NUMBER_CHUNKS[2])}`;
};